"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupRadioGroupKeyboardAccess = exports.mapTopicTypeToRadioId = exports.dispatchInputEvents = exports.checkRadioButton = void 0;

/**
 * Utility functions for Form Prefiller
 *
 * INTEGRATION NOTES:
 * - These utilities are designed to work alongside existing form logic
 * - They dispatch standard DOM events that other components can listen for
 * - They don't maintain ongoing state, just set initial values
 */

/**
 * Dispatches change and input events on an element
 *
 * NOTE: These events allow other components (like Marionette views)
 * to react to our prefilled values as if they were user input.
 * This is crucial for integrating with existing form behaviors.
 */
var dispatchInputEvents = function dispatchInputEvents(element) {
  element.dispatchEvent(new Event('change', {
    bubbles: true
  }));
  element.dispatchEvent(new Event('input', {
    bubbles: true
  }));
};
/**
 * Checks if a radio button with given ID exists and sets it to checked
 * Also simulates a click on the corresponding label to ensure proper Marionette UI updates
 *
 * NOTE: This works with Marionette's topic type switching by:
 * 1. Simulating a click on the label to trigger Marionette event handlers
 * 2. Ensuring the radio input is checked
 * 3. Dispatching proper events that Marionette listens for
 */


exports.dispatchInputEvents = dispatchInputEvents;

var checkRadioButton = function checkRadioButton(radioId) {
  var radio = document.getElementById(radioId);

  if (radio) {
    // Find the associated label for this radio button
    var label = document.querySelector("label[for=\"".concat(radioId, "\"]")); // Simulate click on the label first to properly trigger Marionette's UI updates

    if (label) {
      // First, make sure other buttons don't have is-active class
      document.querySelectorAll('.radio-box-button').forEach(function (el) {
        el.classList.remove('is-active');
      }); // Add is-active class to this label

      label.classList.add('is-active'); // Simulate a click event on the label

      label.click(); // Update aria-checked for all radios in the group

      var group = label.closest('[role="radiogroup"]');
      var radioDiv = radio.closest('[role="radio"]');

      if (group) {
        group.querySelectorAll('[role="radio"]').forEach(function (el) {
          el.setAttribute('aria-checked', el === radioDiv ? 'true' : 'false');
        });
      }
    } // Ensure the radio button is checked


    radio.checked = true;
    dispatchInputEvents(radio);
    return true;
  }

  return false;
};
/**
 * Maps topic type string to radio button ID
 *
 * NOTE: This mapping aligns with the expected radio button IDs in
 * the CreateTopicWysiwyg Marionette component.
 */


exports.checkRadioButton = checkRadioButton;

var mapTopicTypeToRadioId = function mapTopicTypeToRadioId(typeValue) {
  switch (typeValue.toLowerCase()) {
    case 'question':
      return 'topic_content_type_question';

    case 'conversation':
    case 'discussion':
      return 'topic_content_type_discussion';

    case 'idea':
      return 'topic_content_type_idea';

    default:
      return null;
  }
};

exports.mapTopicTypeToRadioId = mapTopicTypeToRadioId;

var setupRadioGroupKeyboardAccess = function setupRadioGroupKeyboardAccess() {
  document.querySelectorAll('[role="radio"]').forEach(function (radioDiv) {
    radioDiv.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault(); // Find the nested input inside this radio option

        var input = radioDiv.querySelector('input[type="radio"]');

        if (input && !input.checked) {
          checkRadioButton(input.getAttribute('id'));
        }
      }
    });
  });
};

exports.setupRadioGroupKeyboardAccess = setupRadioGroupKeyboardAccess;